module.exports = __webpack_public_path__ + "static/img/chengzhang.fad86944.png";